import { Modal } from "antd";
import * as React from "react";

export const RenderModalResetPasswordMessage = ((props:{isOpen?: boolean, onOk?:()=>void, newPassword?: string})=>{
    const renderModalResetPasswordMessage = () => {
        Modal.success({
            title: 'Reset Password information',
            content: <p>Temporary password set to <b>{props.newPassword}</b>. Advise user to change password within 24 hours or it will expire.</p>,
            onOk() {
                props.onOk()
            },
            
        });
      };


    return(
        <>{props.isOpen ? renderModalResetPasswordMessage() :<></>}</>
    )
})

